import { ChatBasketCommissionRates, ChatBasketRateRow, ChatBasketRateScope } from './types'

/** "Genel" sekmesinin ve kapsamının sabit kodu (backend ile ortak sözleşme). */
export const BASKET_GENERAL_CODE = 'general'

/** Sekmenin varsayılan kodu: `isDefault` işaretli olan, yoksa ilk sekme. */
export function defaultTabCode(rates: ChatBasketCommissionRates): string {
  return (rates.tabs.find(tab => tab.isDefault) ?? rates.tabs[0])?.code ?? ''
}

/** Bir sekmenin chip'leri (kapsamları), payload sırasını koruyarak. */
export function scopesOfTab(rates: ChatBasketCommissionRates, tabCode: string): ChatBasketRateScope[] {
  return rates.scopes.filter(scope => scope.tabCode === tabCode)
}

/**
 * Etkin kapsam: seçili chip o sekmede varsa o, yoksa sekmenin varsayılanı, o da yoksa ilk chip.
 * Sekme değiştiğinde seçimi effect ile sıfırlamak gerekmesin diye saf fonksiyon olarak durur.
 */
export function activeScopeOf(
  scopes: ChatBasketRateScope[],
  selectedScopeCode: string
): ChatBasketRateScope | undefined {
  return (
    scopes.find(scope => scope.code === selectedScopeCode) ??
    scopes.find(scope => scope.isDefault) ??
    scopes[0]
  )
}

/** Bir kapsamın oran satırları, taksit sayısına göre artan. Backend sırasına güvenilmez. */
export function rowsOfScope(rates: ChatBasketCommissionRates, scopeCode: string): ChatBasketRateRow[] {
  return rates.rates
    .filter(rate => rate.scopeCode === scopeCode)
    .slice()
    .sort((a, b) => a.installment - b.installment)
}

/** ISO tarihi gg.aa.yyyy'ye çevirir; ayrıştırılamazsa boş döner (şeritte o parça düşer). */
export function formatBasketDate(value?: string | null): string {
  if (!value) return ''
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) return ''
  return parsed.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

/**
 * Kampanya detay şeridinin metni: "Ad · Şirket · 01.09.2026 – 31.12.2026".
 * Genel kapsamda boş döner (şerit çizilmez). Eksik parçalar sessizce düşer.
 *
 * KESİN KISIT: yalnız ad, şirket ve geçerlilik tarihi gösterilir — depo, ürün alt tipi ve kota
 * bu sözleşmede hiç taşınmaz.
 */
export function campaignDetailParts(scope: ChatBasketRateScope | undefined): string[] {
  if (!scope || scope.code === BASKET_GENERAL_CODE) return []

  const period = [formatBasketDate(scope.startDate), formatBasketDate(scope.endDate)]
    .filter(Boolean)
    .join(' – ')

  return [scope.name, scope.companyNames ?? '', period].filter(part => Boolean(part && part.trim()))
}
